// VueX module to manage different data stored in localStorage

let state = window.localStorage.getItem('user-state') || null
try {
  state = JSON.parse(state)
} catch (e) {
  state = null
  console.log('error loading saved user state', e, state)
}
state = state || {
  dashboard: {
    dateRange: {
      start: null,
      end: null
    },
    machines: []
  },
  dataParams: {
    dateRange: {},
    machine: null,
    testType: null
  }
}

const saveState = () => {
  state = mod.state
  window.localStorage.setItem('user-state', JSON.stringify(state))
}

let mod = {
  namespaced: true,
  state,
  mutations: {
    setDashboard (_state, object) {
      _state.dashboard = {
        ..._state.dashboard,
        ...object
      }
      saveState()
    },
    setDataParams (_state, object) {
      console.log('set data params', object)
      _state.dataParams = {
        ..._state.dataParams,
        ...object
      }
      saveState()
    }
  }
}

export default mod
